export default {
  counter: 'Counter',
  buttonS: 'Button!',
  button:  'Button'
}
